<template v-if="globaljs.mb_staff !== 'Worker'">
	<include-header />
	<ModalRefuse :bill_id="bill_id" :refuseId="refuseId" :refuseName="refuseName" :refuseDate="refuseDate" :refuseMemo="refuseMemo" />

	<section id="lab_charge">
		<div class="content">
			<div class="contIn">
				<div class="sub_cont">
					<div class="boardTit">청구서 관리</div>
					<div class="searchBox">
						<form ref="form_search" id="form_search" @submit.prevent="getModels()">
							<div class="searchRow">
								<div class="searchCont">
									<label for="dentalPartnerSearch" class="form-label required">{{ other_type
										}}명</label>
									<input type="text" class="form-control" v-model="searchModels.partner"
										id="dentalPartnerSearch" :placeholder="`${other_type}명`">
								</div>
								<div class="searchCont">
									<label for="orderDateSearch" class="form-label required">청구 기간</label>
									<input type="date" class="form-control" id="billDateSearch"
										v-model="searchModels.billDateSearch" value="">
									<span class="hyphen">-</span>
									<input type="date" class="form-control" id="billDateSearch2"
										v-model="searchModels.billDateSearch2" value="">
								</div>
								<div>
									<button type="button" class="search_btn" id="searchBtn" @click.prevent="getModels()">검색</button>
									<button type="button" v-show="isSearchActive" class="search_btn reset_btn" @click="searchReset()">초기화</button>
								</div>
							</div>
						</form>
					</div>
					<div class="sub_contBox">
						<form ref="form_bill_update" id="form_bill_update" :action="`${SERVER_URL}/api/app/bill`" @submit.prevent="form_bill_update_submit()" method="post" autocomplete="off">
							<div class="subTitWrap">
								<div class="subTit">[청구서 목록]</div>
								<ul v-if="globaljs.acc_type === 'lab'" class="subBtn">
									<li><button type="button" id="CompleteBtn" @click="form_bill_update_submit()">정산완료</button></li>
								</ul>
							</div>
							<table class="group_table">
								<thead>
									<tr>
										<th v-if="globaljs.acc_type === 'lab'" class="chargeCols1"><input type="checkbox" id="chk_all" @click="checkAll($event)"></th>
										<th class="chargeCols2">ID</th>
										<th class="chargeCols3">접수번호</th>
										<th class="chargeCols4">최초 발행일</th>
										<th class="chargeCols5">주문일</th>
										<th class="chargeCols6">출고 완료일</th>
										<th class="chargeCols7">{{ other_type }}</th>
										<th class="chargeCols8">환자명</th>
										<th class="chargeCols9">기공합계금액</th>
										<th class="chargeCols10">청구금액</th>
										<th class="chargeCols11">청구서 상태</th>
										<th class="chargeCols12">정산유형</th>
									</tr>
								</thead>
								<tbody v-if="paginatedItems.length > 0">
									<template v-for="(item, index) in paginatedItems" :key="index">
										<tr v-for="(aiorder, idx) in item.aiorders" :key="idx" :class="getClass(idx)">
											<td v-if="globaljs.acc_type === 'lab' && idx === 0" class="chargeCols1" :class="item.aiorders.length > 1 && idx > 0" :rowspan="item.aiorders.length">
												<input
												v-if="item.bill_status === 'bils1' && item.calc_status === 'type1'" type="checkbox" :name="'chk[]'" class="chk" :value="item.id" />
											</td>
											<td v-if="idx === 0" :rowspan="item.aiorders.length" class="chargeCols2">
												{{ item.id }}
											</td>
											<td class="chargeCols3">{{ aiorder.aiorder_no }}</td>
											<td class="chargeCols4">{{ commonjs.dateFormatYMD(item.firstbill_datetime) }}</td>
											<td class="chargeCols5">{{ commonjs.dateFormatYMD(orderJsonData[aiorder.id].registerDate) }}
											</td>
											<td class="chargeCols6">{{ commonjs.dateFormatYMD(aiorder.order_complete_datetime) }}</td>
										<template v-if="globaljs.acc_type === 'lab'">
											<td v-if="typeof billJsonData[item.id].hospitalName === 'string'" class="chargeCols7">{{ billJsonData[item.id].hospitalName }}</td>
											<td v-else class="chargeCols7">{{ billJsonData[item.id].hospitalName[0] }}</td>
										</template>
										<template v-if="globaljs.acc_type === 'hospital'">
											<td v-if="typeof billJsonData[item.id].labName === 'string'" class="chargeCols7">{{ billJsonData[item.id].labName }}</td>
											<td v-else class="chargeCols7">{{ billJsonData[item.id].labName[0] }}</td>
										</template>
											<td class="chargeCols8">{{ typeof billJsonData[item.id].patientName === 'string' ? billJsonData[item.id].patientName : billJsonData[item.id].patientName[0] }}</td>
											<td class="chargeCols9 text-lightgray"> {{ calc_price_sum(item, idx) }}</td>
											<td v-if="idx === 0" :rowspan="item.aiorders.length" class="chargeCols10 text-blue">
												{{ Number(billJsonData[item.id].total_price).toLocaleString() }}
												<div v-if="Number(billJsonData[item.id].chargeAdjust) > 0" class="text-orange">
													(-{{ Number(billJsonData[item.id].chargeAdjust).toLocaleString() }})
												</div>
											</td>
											<td v-if="idx === 0" :rowspan="item.aiorders.length" class="chargeCols11">
												<div class="charge_bils" :class="`charge_${item.bill_status}`" :data_bill_idx="item.id" @click="handleClick(item)">
													{{ status_t(item.bill_status) }}
												</div>
											</td>
											<td v-if="idx === 0" :rowspan="item.aiorders.length" class="chargeCols12">
												<div class="charge_type" :class="`charge_${item.calc_status}`">
													{{ status_t2(item.calc_status) }}
												</div>
											</td>
										</tr>
									</template>
								</tbody>
								<tbody v-else>
									<tr>
										<td colspan="10">데이터가 없습니다.</td>
									</tr>
								</tbody>

							</table>
						</form>

						<div class="page">
							<ul :id="HZpaginationId" class="pagination">
								<li :class="HZpaginationArrowsClass" v-show="currentPage > 1" @click="previousPage">&lt;</li>
								<li>
									<ul class="num_wrap">
										<li v-for="page in pagesToShow" :key="page"
											:class="['paginacaoValor', HZpaginationCustomClass, { 'active': currentPage === page }, 'num']"
											@click="goToPage(page)">
											{{ page }}
										</li>
									</ul>
								</li>
								<li :class="HZpaginationArrowsClass" v-show="currentPage < totalPages" @click="nextPage">&gt;</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>

	</section>

	<include-footer />
</template>

<script>
import header from '../components/layout/header.vue'
import footer from '../components/layout/footer.vue'

export default {
	name: 'App',
	components: {
		'include-header': header,
		'include-footer': footer
	}
}
</script>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';
import ModalRefuse from '@/components/layout/modal_refuse_data.vue';

const route = useRoute();
const router = useRouter();

if(globaljs.mb_staff === 'Worker') { commonjs.authSwal(); }

let other_type = ref(null);
if (globaljs.acc_type === 'lab') {
	other_type.value = "치과";
} else {
	other_type.value = "기공소";
}

let submitingFlag = false; // 플래그 변수
const withSubmitFlag = async (asyncFunc) => {
	if (submitingFlag) return; // 요청 중복 방지
		submitingFlag = true; // 요청 시작 시 플래그 설정
	try {
		await asyncFunc(); // 비동기 함수 실행
	} finally {
		submitingFlag = false; // 요청이 끝나면 플래그 해제
	}
};

const goto_url = (url) => {
	router.push(url);
}

let form_search = ref(null)
let searchModels = ref({})

onMounted(async () => {
	if(globaljs.mb_staff !== 'Worker') { 
		await getModels();
	}
});

// 초기화 함수
const searchReset = async () => {
	searchModels.value = Object.assign({});
	form_search.value.reset();
	document.querySelectorAll('form#form_search select').forEach(function (selectElement) {
		selectElement.value = '';
		selectElement.selected = true;
	});

	await getModels();
}

// 하나라도 검색 조건이 지정되어 있는지 확인
const isSearchActive = computed(() => {
	return Object.values(searchModels.value).some(value => value !== '');
});

const HZwrapper = 'paginationTable';
const HZlines = 'tableItem';
const HZperPage = 15;
const HZpaginationId = 'pagination-container';
const HZpaginationArrowsClass = 'paginacaoCursor';
const HZpaginationCustomClass = 'customPagination';
const currentPage = ref(1);
const totalPages = computed(() => Math.ceil(items.value.length / HZperPage));

const paginatedItems = computed(() => {
	const start = (currentPage.value - 1) * HZperPage;
	const end = start + HZperPage;
	return items.value.slice(start, end);
});

const goToPage = (page) => {
	if (page > 0 && page <= totalPages.value) {
		currentPage.value = page;
	}
};

const previousPage = () => {
	if (currentPage.value > 1) {
		currentPage.value--;
	}
};

const nextPage = () => {
	if (currentPage.value < totalPages.value) {
		currentPage.value++;
	}
};

const pagesToShow = computed(() => {
	const pages = [];
	const totalPagesValue = totalPages.value;
	const currentPageValue = currentPage.value;
	const showPagesCount = 10; // 한번에 보여줄 페이지 번호 개수
	const halfShowPagesCount = Math.floor(showPagesCount / 2);

	let start = Math.max(1, currentPageValue - halfShowPagesCount);
	let end = Math.min(totalPagesValue, currentPageValue + halfShowPagesCount);

	if (currentPageValue <= halfShowPagesCount) {
		end = Math.min(totalPagesValue, showPagesCount);
	}

	if (currentPageValue > totalPagesValue - halfShowPagesCount) {
		start = Math.max(1, totalPagesValue - showPagesCount + 1);
	}

	for (let i = start; i <= end; i++) {
		pages.push(i);
	}

	return pages;
});

const checkAll = (event) => {
	const checkboxes = document.querySelectorAll('.chk');
	checkboxes.forEach(checkbox => {
		checkbox.checked = event.target.checked;
	});
};

const status_t = ((status) => {
	let text = '';
	switch (status) {
		case 'bils1':
			text = '승인';
			break;
		case 'bils2':
			text = '발행';
			break;
		case 'bils3':
			text = '미발행';
			break;
		case 'bils4':
			text = '반려';
			break;

		default:
			text = '-';
			break;
	}
	return text;
});

const status_t2 = ((status) => {
	let text = '';
	switch (status) {
		case 'type1':
			text = '정산대기';
			break;
		case 'type2':
			text = '정산완료';
			break;

		default:
			text = '-';
			break;
	}
	return text;
});

const getClass = (idx) => {
	const classBool = idx % 2 === 0;
	return {
		'tr_parent': idx === 0,
		'tr_child': idx !== 0,
		'tr_odd': classBool,
		'tr_even': !classBool
	};
};

const bill_id = ref('');
const refuseMemo = ref('');
const refuseId = ref('');
const refuseName = ref('');
const refuseDate = ref('');

const handleClick = (item) => {
	if (item.bill_status !== 'bils4') {
		commonjs.billPopup(`/bill_view/${item.id}`);
	} else {
		bill_id.value = item.id;
		refuseId.value = item.confirm_mb_id;
		refuseName.value = item.confirm_member.mb_name;
		refuseDate.value = item.confirm_datetime; //
		refuseMemo.value = item.bill_memo;

		document.documentElement.style.overflow = 'hidden';
		document.body.style.overflow = 'hidden';
		document.querySelector('#modal_refuse_data').style.display = 'block';
		document.querySelector('.modal_bg').style.display = 'block';

		/*
		<template v-if="globaljs.acc_type === 'lab'">
			<td v-if="typeof billJsonData[item.id].hospitalName === 'string'" class="chargeCols6">{{ billJsonData[item.id].hospitalName }}</td>
			<td v-else class="chargeCols6">{{ billJsonData[item.id].hospitalName[0] }}</td>
		</template>
		<template v-if="globaljs.acc_type === 'hospital'">
			<td v-if="typeof billJsonData[item.id].labName === 'string'" class="chargeCols6">{{ billJsonData[item.id].labName }}</td>
			<td v-else class="chargeCols6">{{ billJsonData[item.id].labName[0] }}</td>
		</template>
		*/

		console.log(item);
	}
};

const calc_price_sum = (item, idx) => {
	let price_sum = 0;
	if (typeof billJsonData.value[item.id].price_sum === 'string') {
		return Number(billJsonData.value[item.id].price_sum).toLocaleString();
	} else {
		if (item.aiorders.length > 1) {
			return Number(billJsonData.value[item.id].price_sum[idx]).toLocaleString();
			
		} else {
			billJsonData.value[item.id].price_sum.forEach((price, idx) => { 
				price_sum += Number(price);
			});
			return price_sum.toLocaleString();
		}
	}
}


const items = ref([]);
const billJsonData = ref([]);
const orderJsonData = ref([]);

const getModels = async () => {
	const params = new URLSearchParams();
	params.append('mb_boss_id', globaljs.mb_boss_id);
	params.append('acc_type', globaljs.acc_type);
	//params.append('mb_level', globaljs.mb_level);
	params.append('orderBy', 'id'); // 정렬필드
	params.append('align', 'desc'); // 정렬순서

	if (searchModels.value != undefined) {
		Object.keys(searchModels.value).map(v => {
			params.append(v, searchModels.value[v]);
		});
	}

	// URLSearchParams를 객체로 변환
	const object = {};
	params.forEach((value, key) => {
		if (key.endsWith('[]')) {
			const arrayKey = key.slice(0, -2);
			if (!object[arrayKey]) {
				object[arrayKey] = [];
			}
			object[arrayKey].push(value);
		} else {
			object[key] = value;
		}
	});

	// 결과 확인용 로그 출력
	const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
console.info(jsonString);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/bill`, { params });
console.debug(response.data.result);
		items.value = response.data.result;
		currentPage.value = 1; // 240822 1페이지로 고정
		for (let i = 0; i < items.value.length; i++) {
			billJsonData.value[items.value[i].id] = JSON.parse(items.value[i].bill_json_data);
			for (let j = 0; j < items.value[i].aiorders.length; j++) {
				// orderJsonData.value.push(JSON.parse(items.value[i].aiorders[j].order_json_data));
				// 241022 파싱할때 특수문자 오류. sanitizeJSONString함수 추가.
				const sanitizedData = commonjs.sanitizeJSONString(items.value[i].aiorders[j].order_json_data);
				orderJsonData.value[items.value[i].aiorders[j].id] = JSON.parse(sanitizedData);
			}
		}
console.debug(billJsonData.value);
console.debug(orderJsonData.value);
	} catch (error) {
console.error('Error getModels:', error);
	}
}

/*
const handleCheckboxChange = (itemId) => {
	const index = this.checkedItems.indexOf(itemId);
	if (index > -1) {
		this.checkedItems.splice(index, 1);
	} else {
		this.checkedItems.push(itemId);
	}
	this.saveCheckedItems();
}
*/

async function form_bill_update_submit() {
	await withSubmitFlag(async () => {
		if (globaljs.acc_type === 'lab') {
			const enabledInputs = document.querySelectorAll("input[type='checkbox'].chk:checked");
			// enabledInputs의 길이를 카운팅합니다.
			const count = enabledInputs.length;
			if (count < 1) {
				commonjs.formSwal('필수 선택', '정산완료 할 항목을 하나 이상 선택해주세요.', '#chk_all', 'self');
				return false;
			}

			const params = new URLSearchParams();
			params.append('mb_boss_id', globaljs.mb_boss_id);
			params.append('acc_type', globaljs.acc_type);
			//params.append('mb_level', globaljs.mb_level);

			const formElement = document.getElementById('form_bill_update');
			const essentials = formElement.querySelectorAll('[required]');
			for (const element of essentials) {
				if (!element.value || element.value.trim() === '' || element.value.trim().length < 1) {
					const label = formElement.querySelector(`label[for="${element.id}"]`);
					const fieldName = label ? label.textContent.replace(':', '') : element.name;
					commonjs.formSwal(`필수 입력`, `[${fieldName}]은 필수 입력 항목입니다.`, `#${element.id}`, 'self');
					return false;
				}

				// input type="date"의 경우 날짜 형식 검증
				if (element.type === 'date' && !commonjs.isValidDate(element.value)) {
					const label = formElement.querySelector(`label[for="${element.id}"]`);
					const fieldName = label ? label.textContent.replace(':', '') : element.name;
					commonjs.formSwal(`날짜 형식 오류`, `[${fieldName}]의 날짜 형식이 올바르지 않습니다.`, `#${element.id}`, 'self');
					return false;
				}
			}

			formElement.querySelectorAll('input').forEach((input) => {
				if (input.type === 'checkbox' && input.id !== 'chk_all' && input.name !== "") {
					if (input.checked) {
						if (!params.has(input.name)) {
							params.append(input.name, input.value);
						} else {
							const existingValue = params.get(input.name);
							params.set(input.name, `${existingValue},${input.value}`);
						}
					}
				} else if (input.type === 'radio' && input.name !== "") {
					if (input.checked) {
						params.append(input.name, input.value);
					}
				} else if (input.name) { // input.name이 존재하는 경우에만 추가
					params.append(input.name, input.value);
				}
			});

			formElement.querySelectorAll('select').forEach((select) => {
				if (select.name) { // select.name이 존재하는 경우에만 추가
					params.append(select.name, select.value);
				}
			});

			formElement.querySelectorAll('textarea').forEach((textarea) => {
				if (textarea.name) { // textarea.name이 존재하는 경우에만 추가
					params.append(textarea.name, textarea.value);
				}
			});

			const bill_confirm = await commonjs.confirmSwal('청구서 정산 확인', '선택된 항목들을 정산완료 처리 하시겠습니까?\n이 작업은 취소할 수 없습니다.', 'nl');
			if (!bill_confirm) {
				return false;
			}

			// URLSearchParams를 객체로 변환
			const object = {};
			params.forEach((value, key) => {
				if (key.endsWith('[]')) {
					const arrayKey = key.slice(0, -2);
					if (!object[arrayKey]) {
						object[arrayKey] = [];
					}
					object[arrayKey].push(value);
				} else {
					object[key] = value;
				}
			});

			// 결과 확인용 로그 출력
			const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
	console.info(jsonString);

			try {
				const response = await axios.put(`${SERVER_URL}/api/app/bill/calc`, params);
	console.debug(response.data.result);
				toast.fire({
					icon: "success",
					title: "청구서를 정산완료했습니다."
				});

				getModels();
			} catch (error) {
				console.error(error?.response?.data);
				commonjs.formSwal(`필수 입력`, error?.response?.data?.errors[0]?.msg);
			}
		}
	});
}
</script>